export const ANALYTICS_TAGS_WIZARD_TEXT = {
  step: 'analytics-tags',
  title: 'Analytics Tags',
  description: 'We recommend adding analytics tags that can be used to filter and compare performance of various QR Codes. ',
  linkText: 'Learn More.',
  link: 'https://help.branch.io/using-branch/docs/creating-a-deep-link#keys-for-reporting-analytics',
} as const;
